import api from "../services/api";
import { isNativePlatform } from "../capacitor/platform";
import { useAuthStore } from "../pinia/auth";

// performLogout logs out and hard-navigates so the next request hits the
// server-side SAML-only redirect when applicable. Callers should not
// navigate themselves afterwards.
export async function performLogout(): Promise<void> {
  const authStore = useAuthStore();
  try {
    await authStore.logout();
  } catch {
    // logout's finally already cleared persisted state; redirect anyway.
  }

  // Native bypasses /logged-out: the SPA-shell SAML loop the page guards
  // against can't happen in-app.
  if (isNativePlatform()) {
    window.location.assign("/");
    return;
  }

  let disableLocalUserLogin = false;
  try {
    const response = await api.get("/system_status");
    disableLocalUserLogin = Boolean(response.data?.DisableLocalUserLogin);
  } catch {
    // Flag unreadable; fall through to the standard login page.
  }

  window.location.assign(disableLocalUserLogin ? "/logged-out" : "/");
}
